import React from "react";
import { Check, X } from "lucide-react";

const FOR_YOU = [
  "Tens 18+ anos e queres mudar de vida na construção",
  "Estás disposto a estudar e a aprender",
  "Queres o cartão oficial SIGO para trabalhar em obra em Portugal ou na UE",
  "Estás aberto a começar num salário desde ~1.600€ e crescer até 4.000€/mês",
  "Estás disposto a começar na grua de comando e conquistar espaço na grua de cabine no futuro",
  "Queres um método direto, sem enrolação, feito por quem vive a profissão",
];

const NOT_FOR_YOU = [
  "Queres resultado imediato sem estudar nada",
  "Já queres começar na grua de cabine — primeiro apanha experiência na grua de comando e depois evolui para a cabine",
  "Tens medo extremo de alturas (a profissão exige trabalho em altura)",
  "Não estás disposto a respeitar normas de segurança rigorosas",
  "Queres só matar a curiosidade — este curso é para quem leva a sério",
];

export default function WhoIsFor() {
  return (
    <section
      className="py-24 sm:py-32 bg-[#0A0A0A] border-b border-white/10"
      data-testid="who-is-for-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <div className="text-xs uppercase tracking-[0.3em] text-yellow-400 mb-3">
            Vamos ser diretos
          </div>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
            ISTO SERVE <br />
            <span className="text-yellow-400">PARA TI</span>?
          </h2>
          <p className="mt-6 text-zinc-400 max-w-2xl mx-auto">
            Não vamos enganar ninguém. Se te revês aqui, entra. Se não, poupa-te o tempo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {/* É PARA TI */}
          <div className="relative border border-yellow-400/30 bg-gradient-to-b from-yellow-400/5 to-transparent p-7 sm:p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-yellow-400 flex items-center justify-center">
                <Check className="w-7 h-7 text-black" strokeWidth={3} />
              </div>
              <h3 className="font-display text-2xl sm:text-3xl text-white uppercase">
                É para ti se...
              </h3>
            </div>
            <ul className="space-y-3">
              {FOR_YOU.map((item, i) => (
                <li
                  key={i}
                  data-testid={`who-for-item-${i}`}
                  className="flex items-start gap-3 text-zinc-200 text-[15px] leading-relaxed"
                >
                  <Check className="w-5 h-5 text-yellow-400 shrink-0 mt-0.5" strokeWidth={2.5} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* NÃO É PARA TI */}
          <div className="relative border border-red-600/30 bg-gradient-to-b from-red-600/5 to-transparent p-7 sm:p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-red-500 flex items-center justify-center">
                <X className="w-7 h-7 text-white" strokeWidth={3} />
              </div>
              <h3 className="font-display text-2xl sm:text-3xl text-white uppercase">
                NÃO é para ti se...
              </h3>
            </div>
            <ul className="space-y-3">
              {NOT_FOR_YOU.map((item, i) => (
                <li
                  key={i}
                  data-testid={`who-notfor-item-${i}`}
                  className="flex items-start gap-3 text-zinc-400 text-[15px] leading-relaxed"
                >
                  <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" strokeWidth={2.5} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
